import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Url } from '@wix/da-url';
import s from './SubscribeButton.scss';
var SubscribeButton = function (_a) {
    var user = _a.user, relevantDeviation = _a.relevantDeviation;
    var t = useTranslation().t;
    var newMsPromo = useFlag('mobile_tier_promo_new');
    return (React.createElement(BiLink, { className: s['root'], href: Url.userSubscriptionsPath({
            username: user.username,
        }), biData: relevantDeviation &&
            BiData({
                evid: 547,
                typeid: relevantDeviation.typeId,
                itemid: relevantDeviation.deviationId,
                referral_info: ReferralType.ART_STAGE_PROMOTION,
            }) }, t(newMsPromo
        ? 'submissionDetailsHeader.tierPromotion.button.subscribe.new'
        : 'submissionDetailsHeader.tierPromotion.button.subscribe')));
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map